module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/ltv_features_05-51ba4280c636675731f4c0172f56800f.png";